export default {
    manage_deletedCrew: "Miembro de Tripulación fue eliminado exitosamente",
    manage_deletedCrews: "Miembros de Tripulación fueron eliminados exitosamente",
    manage_deleteManageCrew_deleteCrew: "Eliminar Miembro de Tripulación",
    manage_deleteManageCrew_deleteCrews: "Eliminar Miembros de Tripulación",
    manage_deleteManageCrew_confirmationMessage:
      "¿Está seguro de que desea eliminar a los siguientes Miembros de Tripulación?",
  };
  